/**
 * Tri au clic sur un en-tête, le même pour les tableaux du suivi et ceux du
 * site : croissant, décroissant, puis retour à l'ordre d'origine.
 * Un tri : `{ key, dir }`, ou null.
 */
export const nextSort = (current, key) => {
  if (current?.key !== key) return { key, dir: 'asc' };
  return current.dir === 'asc' ? { key, dir: 'desc' } : null;
};

export const ariaSort = (dir) => ({ asc: 'ascending', desc: 'descending' }[dir] || 'none');
